import { StackProps } from '@chakra-ui/react';
import { TaxProviderTypeEnum } from '@monetize/types/app';
import { FC } from 'react';
import { MdLock } from 'react-icons/md';
import { MIcon, MImage } from '../../../../../components/Monetize';
import { ButtonCard } from '../../../../../components/Monetize/Cards/ButtonCard';
import { TAX_PROVIDER_DISPLAY } from '../../../../../constants/taxes';

interface TaxCardEmptyProps extends StackProps {
  type: TaxProviderTypeEnum;
  isLocked?: boolean;
  isDisabled?: boolean;
  onClick?: () => void;
}

export const TaxCardEmpty: FC<TaxCardEmptyProps> = ({
  type,
  isLocked,
  isDisabled,
  onClick,
  ...rest
}) => {
  const provider = TAX_PROVIDER_DISPLAY[type];
  if (!provider) {
    return null;
  }

  return (
    <ButtonCard
      h="82px"
      titleLeftContent={
        <MImage
          maxH="25px"
          maxW="80px"
          src={provider.icon}
          opacity={isDisabled ? 0.5 : 1}
          objectFit="contain"
        />
      }
      title={provider.name}
      description={`Connect to ${provider.name}`}
      isDisabled={isLocked || isDisabled}
      titleRightContent={
        isLocked ? (
          <MIcon as={MdLock} w={3} h={3} mt={1} color="tPurple.dark" />
        ) : undefined
      }
      width={isLocked ? '100%' : undefined}
      onClick={isDisabled ? undefined : onClick}
      cursor={isDisabled ? 'not-allowed' : undefined}
      w="auto"
      {...rest}
    />
  );
};
